import { type ReactElement, useId, useState } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * "Ungeprüft übernehmen" for a logo the security check could not clear: the file stays the
 * one just chosen, the tenant admin names a reason, and the audit row keeps it. Like the
 * release of an unscanned contribution, and only shown to the tenant admin, who alone may do
 * it (the API refuses everyone else). A file the check refused is never offered this.
 */
export function UnscannedAccept({
  busy,
  onAccept,
}: {
  readonly busy: boolean;
  readonly onAccept: (reason: string) => void;
}): ReactElement {
  const id = useId();
  const [reason, setReason] = useState("");
  const usable = reason.trim().length >= 3;

  return (
    <div className="mt-4 grid gap-2 border border-border bg-surface-sunken p-3">
      <p className="text-sm">
        Die Datei konnte nicht geprüft werden. Mit der Berechtigung »Störfall« können Sie sie
        trotzdem übernehmen; der Grund steht danach im Protokoll.
      </p>
      <Label htmlFor={`${id}-reason`}>Grund</Label>
      <Input
        id={`${id}-reason`}
        value={reason}
        maxLength={500}
        disabled={busy}
        placeholder="z. B. Datei selbst geprüft, Prüfung auf dieser Umgebung nicht verfügbar"
        onChange={(event) => {
          setReason(event.target.value);
        }}
      />
      <Button
        type="button"
        variant="outline"
        className="w-max"
        disabled={busy || !usable}
        onClick={() => {
          onAccept(reason.trim());
        }}
      >
        Ungeprüft übernehmen
      </Button>
    </div>
  );
}
